import { Chart } from '@frontend/chart/types';

import { createSingleSeriesTimeSeriesMockData } from '../../../mocks/create-time-series-mock-data';

const gloves = createSingleSeriesTimeSeriesMockData({ days: 30, scale: 4, seriesName: 'Safety gloves' });
const boots = createSingleSeriesTimeSeriesMockData({ days: 30, scale: 3, seriesName: 'Work boots' });
const vest = createSingleSeriesTimeSeriesMockData({ days: 30, scale: 2, seriesName: 'Hi-vis vest' });

export const FILL_RATE_BY_PRODUCT_LINE_CHART_MOCK_DATA: Chart = {
    series: [gloves.series[0], boots.series[0], vest.series[0]]
};
